import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { getAuthUrl } from "@/services/UrlGeneration";
/** The event's voter login and enrollment links, and the kiosk's when it votes by kiosk. */
export var VoterPortalLinks = function (_a) {
    var _b, _c, _d;
    var electionEvent = _a.electionEvent;
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var eventId = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.id;
    if (!tenantId || !eventId) {
        return null;
    }
    var portalUrl = globalSettings.VOTING_PORTAL_URL;
    var kioskPortalUrl = ((_b = globalSettings.KIOSK_VOTING_PORTAL_URL) === null || _b === void 0 ? void 0 : _b.trim()) || portalUrl;
    var channels = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.voting_channels;
    var links = [
        {
            key: "login",
            label: t("dashboard.voterLoginURL"),
            href: (_c = getAuthUrl(portalUrl, tenantId, eventId, "login")) !== null && _c !== void 0 ? _c : "",
        },
        {
            key: "enroll",
            label: t("dashboard.voterEnrollURL"),
            href: (_d = getAuthUrl(portalUrl, tenantId, eventId, "enroll")) !== null && _d !== void 0 ? _d : "",
        },
    ];
    if ((channels === null || channels === void 0 ? void 0 : channels.kiosk) === true) {
        var kioskUrl = getAuthUrl(kioskPortalUrl, tenantId, eventId, "login");
        links.push({
            key: "kiosk",
            label: t("dashboard.voterEnrollKioskURL"),
            href: kioskUrl ? "".concat(kioskUrl, "?kiosk") : "",
        });
    }
    return (_jsx(Box, { sx: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            columnGap: "20px",
            rowGap: "4px",
            paddingTop: "10px",
        }, children: links.map(function (link, index) { return (_jsxs(React.Fragment, { children: [index > 0 && _jsx("p", { "aria-hidden": "true", children: "|" }), _jsx("a", { href: link.href, target: "_blank", rel: "noopener noreferrer", children: link.label })] }, link.key)); }) }));
};
